<template>
  <footer class="bg-white">
 
  </footer>
</template>

<script>
export default {};
</script>

<style>
</style>